export default "__VITE_ASSET__8VIYC0ZO__"